// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const WIKI_EXPERIENCE_SENT_TOAST = "Tvoje zku\u0161enost byla odeslan\u00e1. D\u00edky!";
